export const isWindowDefined = (): boolean => {
  return typeof window !== "undefined";
};
